export function randomNumberGenerator(min, max, decimal?: any) {
  const randomNumber = Math.random() * (max - min) + min;

  if (decimal === 0) {
    return Math.round(randomNumber);
  }

  if (decimal > 0) {
    return randomNumber.toFixed(decimal);
  }

  return randomNumber;
}
